module.exports = __webpack_public_path__ + "img/profile.bd4e4d3c.svg";